import React, {useEffect} from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from "./components/ScrollToTop";


import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import Footer from './components/Footer';
import ContactPage from './pages/ContactPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ServicesPage from './pages/ServicesPage';
import MobilierPage from "./components/category/MobilierPage";
import HorlogeriePage from "./components/category/HorlogeriePage";
import BijouxPage from "./components/category/BijouxPage";
import JouetsPage from "./components/category/JouetsPage";
import MilitairePage from "./components/category/MilitairePage";
import ArtPage from "./components/category/ArtPage";
import PorcelainePage from "./components/category/PorcelainePage";
import LivresPage from "./components/category/LivresPage";
import TapisseriePage from "./components/category/TapisseriePage";
import SculpturePage from "./components/category/SculpturePage";
import ArgenteriePage from "./components/category/ArgenteriePage";
import ArtsAsiatiquesPage from "./components/category/ArtsAsiatiquesPage";
import InstrumentDeMusiquePage from "./components/category/InstrumentDeMusiquePage";
import CeramiquesPage from "./components/category/CeramiquesPage";
import VinEtSpiritueuxPage from "./components/category/VinEtSpiritueuxPage";
import ObjetsPage from "./components/ObjetsPage";
import ZoneDInterventionPage from "./pages/ZoneDInterventionPage";
import {initGA, logPageView} from "./analytics";
import VoituresPage from "./components/category/Voitures";
import MonnaiePage from "./components/category/Monnaie";
import Zone75 from "./pages/Zone75";
import Zone77 from "./pages/Zone77";
import Zone93 from "./pages/Zone93";
import Zone94 from "./pages/Zone94";
import Zone91 from "./pages/Zone91";
import Zone78 from "./pages/Zone78";
import EstimationPage from "./pages/EstimationPage";

export const routes = [
    { name: 'Mobilier', path: '/mobilier' },
    { name: 'Horlogerie', path: '/horlogerie' },
    { name: 'Bijoux', path: '/bijoux' },
    { name: 'Jouets', path: '/jouets' },
    { name: 'Militaire', path: '/militaire' },
    { name: 'Art', path: '/art' },
    { name: 'Porcelaine', path: '/porcelaine' },
    { name: 'Tapisserie', path: '/tapisserie' },
    { name: 'Arts Asiatiques', path: '/arts-asiatiques' },
    { name: 'Sculpture', path: '/sculpture' },
    { name: 'Argenterie', path: '/argenterie' },
    { name: 'Instrument de Musique', path: '/instrument-de-musique' },
    { name: 'Céramiques', path: '/ceramiques' },
    { name: 'Vin & Spiritueux', path: '/vin-et-spiritueux' },
    { name: 'Zone d\'intervention', path: '/zone-d-intervention' },
    { name: 'Témoignages', path: '/temoignages' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
    { name: 'A propos', path: '/about' },
    { name: 'Objets', path: '/objets' },
    { name: 'Accueil', path: '/' },
    { name: 'Voitures', path: '/voitures' },
    { name: 'Monnaie', path: '/monnaie' },
];

function App() {
    useEffect(() => {
        initGA("G-X82B4T5KTM");
        logPageView();
    }, []);
    return (
        <HelmetProvider>
        <Router>
            <ScrollToTop />
            <div className="App">
                <Navbar />

                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/objets" element={<ObjetsPage />} />
                    <Route path="/estimation-offerte" element={<EstimationPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/temoignages" element={<TestimonialsPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/mobilier" element={<MobilierPage />} />
                    <Route path="/horlogerie" element={<HorlogeriePage />} />
                    <Route path="/bijoux" element={<BijouxPage />} />
                    <Route path="/jouets" element={<JouetsPage />} />
                    <Route path="/militaire" element={<MilitairePage />} />
                    <Route path="/art" element={<ArtPage />} />
                    <Route path="/porcelaine" element={<PorcelainePage />} />
                    <Route path="/livres" element={<LivresPage />} />
                    <Route path="/tapisserie" element={<TapisseriePage />} />
                    <Route path="/arts-asiatiques" element={<ArtsAsiatiquesPage />} />
                    <Route path="/sculpture" element={<SculpturePage />} />
                    <Route path="/argenterie" element={<ArgenteriePage />} />
                    <Route path="/instrument-de-musique" element={<InstrumentDeMusiquePage />} />
                    <Route path="/ceramiques" element={<CeramiquesPage />} />
                    <Route path="/vin-et-spiritueux" element={<VinEtSpiritueuxPage />} />
                    <Route path="/zone-d-intervention" element={<ZoneDInterventionPage />} />
                    <Route path="/voitures" element={<VoituresPage />} />
                    <Route path="/monnaie" element={<MonnaiePage />} />
                    <Route path="/zone-d-intervention/77" element={<Zone77 />} />
                    <Route path="/zone-d-intervention/93" element={<Zone93 />} />
                    <Route path="/zone-d-intervention/94" element={<Zone94 />} />
                    <Route path="/zone-d-intervention/91" element={<Zone91 />} />
                    <Route path="/zone-d-intervention/78" element={<Zone78 />} />
                    <Route path="/zone-d-intervention/75" element={<Zone75 />} />
                </Routes>


                <Footer />
            </div>
        </Router>
        </HelmetProvider>
    );
}

export default App;
